var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pi-qrcode-wrap"},[_c('div',{ref:"qrcodeDiv",staticClass:"pi-qrcode-show"}),(_vm.isShowUrl)?_c('p',{staticClass:"pi-top-10"},[_vm._v(_vm._s(_vm.url))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }